// Thin API client for the 606FITNESS mobile-app backend.
// All requests go to REACT_APP_APP_API_URL (the app's API), NOT the website's own backend.
import axios from "axios";

const API_URL = process.env.REACT_APP_APP_API_URL;

const client = axios.create({
    baseURL: API_URL,
    timeout: 15000,
});

// Helper: surface a clean error string (Arabic-friendly through i18n keys)
const normalizeError = (err) => {
    if (!err.response) {
        // network / cors
        const e = new Error("network");
        e.code = "network";
        throw e;
    }
    const status = err.response.status;
    const data = err.response.data || {};
    const message = data.message || data.detail || data.error;
    const e = new Error(message || `http_${status}`);
    e.status = status;
    e.payload = data;
    if (status === 401 || status === 403) e.code = "invalidCredentials";
    throw e;
};

export const authApi = {
    async login(email, password) {
        try {
            const { data } = await client.post("/auth/login", { email, password });
            return data; // { token, user }
        } catch (e) {
            normalizeError(e);
        }
    },

    async me(token) {
        try {
            const { data } = await client.get("/auth/me", {
                headers: { Authorization: `Bearer ${token}` },
            });
            return data;
        } catch (e) {
            normalizeError(e);
        }
    },

    async deleteAccount(token, reason = "") {
        try {
            const { data } = await client.delete("/auth/me", {
                headers: { Authorization: `Bearer ${token}` },
                data: { confirm: "DELETE", reason },
            });
            return data;
        } catch (e) {
            normalizeError(e);
        }
    },

    async forgotPassword(email) {
        try {
            const { data } = await client.post("/auth/forgot-password", { email });
            return data;
        } catch (e) {
            normalizeError(e);
        }
    },

    async resetPassword(email, code, newPassword) {
        try {
            const { data } = await client.post("/auth/reset-password", {
                email,
                code,
                new_password: newPassword,
            });
            return data;
        } catch (e) {
            normalizeError(e);
        }
    },
};
